module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.browse', {
            abstract: true,
            data: {
            },
            views: {
                'center-panel@': {
                    template: '<wow-categories></wow-categories>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })
        .state('shop.browse.productnotfound', {
            url: '/product-not-found',
            views: {
                'center-panel@': {
                    template: '<wow-error-page error-page="\'productNotFound\'"></wow-error-page>'
                },
                'sticky-header@': {
                    controller: [
                        'BreakpointsService', 'SettingsService', '$scope', '$timeout',
                        function (breakpointsService, settingsService, $scope, $timeout) {
                            $scope.showHeader = false;
                            $scope.breakpointsService = breakpointsService;

                            settingsService.getSettingValue('OneSite', 'SmallFormatCentrePanelSlideEnabled').then(function (setting) {
                                $scope.smallFormatCentrePanelSlideEnabled = setting;
                            });

                            $scope.title = 'Product Not Found';

                            $scope.redirectTo = 'shop.browse';

                            $timeout(function () {
                                $scope.showHeader = true;
                            }, 500);
                        }
                    ],
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isSmallFormat() && smallFormatCentrePanelSlideEnabled" ng-show="showHeader"></oly-sticky-header-with-text>'
                }
            },
            data: {
                shouldGetMetadata: false,
                showBothPanelsInSmallFormat: true,
                analytics: `bws:web:product-not-found`
            }
        })
        .state('shop.browse.department', {
            url: '/:department?{filters}&{sortby}&{pageNumber:int}',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:${$state.params.department}`;
                    }
                ],
                showBothPanelsInSmallFormat: true
            },
            views: {
              'left-panel@': {
                  template: '<wow-filters-mobile></wow-filters-mobile>'
              },
              'center-panel@': {
                  template: '<bws-category></bws-category>'
              }
            }
        })
        .state('shop.browse.department.subdepartment', {
            url: '/:subdepartment',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:plp:${$state.params.department}:${$state.params.subdepartment}`;
                    }
                ]
            },
            resolve: {
                deps: ['$$animateJs', '$ocLazyLoad', function ($$animateJs, $ocLazyLoad) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[5].files[0]);
                }]
            },
            views: {
                'center-panel@': {
                    template: '<bws-category></bws-category>'
                },
                'dynamic-content-bottom@': {
                    template: '<wow-recipe-carousel recipes="recipeItems" category="category" category-description="description"></wow-recipe-carousel>',
                    controller: ['$scope', '$timeout', '$location', 'deps', 'RecipesService', 'CacheService', function ($scope, $timeout, $location, deps, recipesService, cacheService) {

                        const pageNumberPattern = /pageNumber\=(\d+)/gi;
                        const url = pageNumberPattern.test($location.$$absUrl)
                            ? $location.$$absUrl
                            : $location.$$absUrl + '?pageNumber=1';

                        function tryLoadRecipeList() {
                            const cached = cacheService.get(url);

                            if (cached && cached.categories) {

                                const category = cached.categories[0].Attributes.recipecategory_urlfriendlydescription;

                                if (category) {

                                    recipesService.getRecipeList(category + '?SortType=CreatedDesc').then((recipes) => {
                                        $scope.recipeItems = recipes.Items;
                                        $scope.category = category;
                                        $scope.description = recipes.Name;
                                    });
                                }

                                return;
                            }

                            $timeout(tryLoadRecipeList, 100);
                        }

                        tryLoadRecipeList();
                    }]
                }
            }
        })
        .state('shop.browse.department.subdepartment.category', {
            url: '/:category',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:plp:${$state.params.department}:${$state.params.subdepartment}:${$state.params.category}`;
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<bws-category></bws-category>'
                }
            }
        })
        .state('shop.browse.department.subdepartment.category.subcategory', {
            url: '/:subcategory',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:plp:${$state.params.subdepartment}:${$state.params.category}:${$state.params.subcategory}`;
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<bws-category></bws-category>'
                }
            }
        });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/browse.js
 **/